export const LOADING = 'BARTHEL_INDEX_LOADING';
// エラーでもFINISH
export const FINISH = 'BARTHEL_INDEX_FINISH';

export const SUCCESS = 'BARTHEL_INDEX_SUCCESS';
export const ERROR = 'BARTHEL_INDEX_ERROR';
